export default __webpack_public_path__ + "static/media/Radio_Inactive.e904f14c.svg";